import { IFormField, IFormSection } from "../web-form.objects"
import _ from "lodash";

export class TextInputOptions {
    wordCount?: number = -99; // if should validate based on words
    isEmail: boolean = false; // should add validation for email
    charCount: number = -99; // if should validate based on characters
    isReadOnly: boolean = false; // if this field should be readonly
    constructor(wordCount: number = -99, isEmail: boolean = false, charCount: number = -99, isReadOnly: boolean = false) {
        this.wordCount = wordCount;
        this.isEmail = isEmail;
        this.charCount = charCount;
        this.isReadOnly = isReadOnly;
    }
}

export class TextInputField implements IFormField {
    fieldId: string; 
    displayName: string; 
    isRequired: boolean;
    propertyName: string; 
    defaultVal: any; 
    formSection: IFormSection;
    shouldTriggerUpdate: boolean = false;
    forObjProperty: boolean = true;
    options: TextInputOptions;

    constructor(propertyName: string, defaultVal: any, fieldId: string, displayName: string, isRequired: boolean, options: TextInputOptions = new TextInputOptions()) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.defaultVal = defaultVal;
        this.options = options;

        if (this.options.isReadOnly) {
            this.forObjProperty = false; // not going to update the saved obj
        }
    }

    initialize(formSection: IFormSection) {
        this.formSection = formSection;

        if (this.options.wordCount > 0) {
            this.initializeWordCount();
        }
        else if (this.options.charCount > 0) {
            this.initializeCharCount();
        }

        this.initializeSectionUpdateTrigger();
    }

    private initializeSectionUpdateTrigger() {
        $(`#${this.fieldId}`).on("keyup change", () => {
            this.triggerSectionUpdate();
        });
    }

    private initializeWordCount() {
        let wordCountDisplay = $(`#${this.fieldId}`).siblings(".word-count-display").find(".word-count-num");
        $(`#${this.fieldId}`).on("keyup change", () => {
            let wordCount = this.getWordCount();
            wordCountDisplay.text(wordCount.toString());
            if (wordCount > this.options.wordCount) {
                this.displayValid(false);
            }
            else { this.resetValidDisplay(); }
        });
    }

    private initializeCharCount() {
        let charCountDisplay = $(`#${this.fieldId}`).siblings(".word-count-display").find(".word-count-num");
        $(`#${this.fieldId}`).on("keyup change", () => {
            let charCount = this.getCharCount();
            charCountDisplay.text(charCount.toString());
            if (charCount > this.options.charCount) {
                this.displayValid(false);
            }
            else { this.resetValidDisplay(); }
        });
    }

    private getWordCount(): number {
        let val = this.getInput();
        if (!val) {
            return 0; // if empty or just spaces
        }
        let wordCount = val.split(" ").length;
        return wordCount;
    }

    private getCharCount(): number {
        let val = this.getInput();
        if (!val) {
            return 0; // if empty or just spaces
        }
        let charCount = val.length;
        return charCount;
    }

    //private getInput(): string {
    //    let input = (<string>$(`#${this.fieldId}`).val()).trim();
    //    return input;
    //}
    private getInput(): string {
        let el = $(`#${this.fieldId}`);
        if (el.length === 0) {
            console.warn(`Element with id '${this.fieldId}' not found.`);
            return "";
        }
        let val = el.val();
        if (typeof val === "string") {
            return val.trim();
        }
        return "";
    }


    private setInput(data: any): void {
        $(`#${this.fieldId}`).val(data);
    }

    getValue(): any {
        let val = this.defaultVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.getInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            this.setInput(formVal);
        }
    }

    checkValid(): boolean {
        let val = this.getInput();

        // word count
        if (this.options.wordCount > 0) {
            let wordCount = this.getWordCount();
            if (wordCount > this.options.wordCount) {
                return false;
            }
        }
        else if (this.options.charCount > 0) {
            let charCount = this.getCharCount();
            if (charCount > this.options.charCount) {
                return false;
            }
        }

        // email
        if (this.options.isEmail) {
            // only test if its not empty
            if (val) {
                let regex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                let isEmailValid = regex.test(val);
                if (!isEmailValid) {
                    return false;
                }
            }
        }

        if (this.isRequired) {
            // empty or spaces
            if (!val) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.getInput();
        if (val != this.defaultVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).removeClass("is-valid").removeClass("is-invalid");
    }

    triggerSectionUpdate() {
        if (this.formSection && this.shouldTriggerUpdate) {
            this.formSection.updateSection();
        }
    }
}

